import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import { confirmAlert } from 'react-confirm-alert';

//stores
import commonStore from './stores/commonStore';
import userStore from './stores/userStore';

//config
import appConfigs from './config';

//localization
import i18n from '../i18n';

const superagent = superagentPromise(_superagent, global.Promise);

const { API_ROOT, BASE_URL, NOTIFICATION_API_ROOT } = appConfigs;

const redirectToLogin = () => {
    window.location.replace(BASE_URL)
}

const handleErrors = (err, response, skipErrors) => {
    if (!err) {
        // no error.
        return null;
    }
    if (err && err.response && err.response.status === 401) {
        if (response && response.body && response.body.errors && response.body.errors.error
            && response.body.errors.error.code && response.body.errors.error.code === 'invalid_token') {
            userStore.forgetUser();
            redirectToLogin();
            if (commonStore) commonStore.addNotification('Token Expired', null, 'error', 'tr', 4000);
            return;
        }
        if (commonStore && response && response.body && response.body.error && typeof response.body.error === 'string') {
            return commonStore.addNotification(i18n.t(response.body.error), null, 'error');
        }
        if (commonStore) commonStore.addNotification('Authentication error', null, 'error');
        return new Error('Authentication error');
    }
    if (err && err.response && err.response.status === 413) {
        if (commonStore) commonStore.addNotification('Payload/File size exceed limit', null, 'error');
        return new Error('Payload/File size exceed limit');
    }
    if (err?.response?.body?.errors?.error_msg && err?.response?.status !== 403 && err?.response?.status !== 405) {
        if (commonStore) commonStore.addNotification(i18n.t(`${err.response.body.errors.error_msg}`), null, 'error');
        return new Error('Please Fill the Details');
    }
    if (err && err.response && (err.response.status === 405 || err.response.status === 403)) {
        commonStore.addNotification(i18n.t(`${response?.body?.error}`), null, 'error');

        const handleSessionExpired = async () => {
            userStore.forgetUser();
            window.sessionStorage.removeItem('cusToken');
            redirectToLogin();
        };
        confirmAlert({
            message: err?.response?.body?.error || i18n.t('Please login again.'),
            buttons: [
                {
                    label: i18n.t('OK'),
                    onClick: handleSessionExpired
                }
            ],
            onClickOutside: handleSessionExpired,
            onKeypressEscape: handleSessionExpired,
        });
        return;
    }

    let text = 'Unknown error connecting to the server';
    console.error(err);
    if (err && response && response.body && response.body.error && typeof response.body.error === 'string') {
        text = response.body.error;
    }

    if (
        err &&
        err.response &&
        err.response.body &&
        err.response.body.errors &&
        err.response.body.errors.error &&
        typeof err.response.body.errors.error === 'string'
    ) {
        text = err.response.body.errors.error;
    }
    if (err && err.response && err.response.body && err.response.body.errors && err.response.body.errors.message) {
        text = err.response.body.errors.message;
    }

    if (commonStore && !skipErrors) commonStore.addNotification(i18n.t(text), null, 'error', "top-right", text.length > 30 ? 3000 : 1000);
    else {
        return new Error(text);
    }
};

const responseBody = (res) => res.body;

const tokenPlugin = (req) => {
    if (commonStore.token) {
        req.set('authorization', `Token ${commonStore.token}`);
    }
    if (window.sessionStorage.getItem('cusToken')) {
        req.set('authorization', `Token ${window.sessionStorage.getItem('cusToken')}`);
    }
    const visitorToken = window.sessionStorage.getItem('visitorSessionToken');
    if (visitorToken) {
        req.set('X-Visitor-Token', visitorToken);
    }
};

const tokenPlugin2FA = (req) => {
    if (window.sessionStorage.getItem('x-setup-2fa-token')) {
        req.set('x-setup-2fa-token', `Token ${window.sessionStorage.getItem('x-setup-2fa-token')}`);
    }
    if (window.sessionStorage.getItem('x-1fa-token')) {
        req.set('x-1fa-token', `Token ${window.sessionStorage.getItem('x-1fa-token')}`);
    }
};

const convertToGetParams = (params) =>
    Object.keys(params).reduce((total, currentValue, currentIndex, arr) => {
        let param = JSON.stringify(params[currentValue]);
        if (!param) {
            return total;
        }
        if (param.indexOf('{') < 0 && param.indexOf('[') < 0) param = param.replace('"', '').replace('"', '');
        return `${total}${currentValue}=${encodeURIComponent(param)}&`;
    }, '?');

const notificationRequests = {
    del: (url) => superagent.del(`${NOTIFICATION_API_ROOT}${url}`).use(tokenPlugin).end(handleErrors).then(responseBody),
    get: (url, skipErrors) =>
        superagent
            .get(`${NOTIFICATION_API_ROOT}${url}`)
            .use(tokenPlugin)
            .use(tokenPlugin2FA)
            .end((e, r) => handleErrors(e, r, skipErrors))
            .then(responseBody),
    put: (url, body, skipErrors) =>
        superagent
            .put(`${NOTIFICATION_API_ROOT}${url}`, body)
            .use(tokenPlugin)
            .use(tokenPlugin2FA)
            .end((e, r) => handleErrors(e, r, skipErrors))
            .then(responseBody),
    post: (url, body, skipErrors) =>
        superagent
            .post(`${NOTIFICATION_API_ROOT}${url}`, body)
            .use(tokenPlugin)
            .use(tokenPlugin2FA)
            .end((e, r) => handleErrors(e, r, skipErrors))
            .then(responseBody),
};

const requests = {
    del: (url, body, skipErrors) =>
        superagent
            .del(`${API_ROOT}${url}`)
            .send(body)
            .use(tokenPlugin)
            .use(tokenPlugin2FA)
            .end((e, r) => handleErrors(e, r, skipErrors))
            .then(responseBody),
    get: (url, skipErrors) =>
        superagent
            .get(`${API_ROOT}${url}`)
            .use(tokenPlugin)
            .use(tokenPlugin2FA)
            .end((e, r) => handleErrors(e, r, skipErrors))
            .then(responseBody),
    put: (url, body, skipErrors) =>
        superagent
            .put(`${API_ROOT}${url}`, body)
            .use(tokenPlugin)
            .use(tokenPlugin2FA)
            .end((e, r) => handleErrors(e, r, skipErrors))
            .then(responseBody),
    post: (url, body, skipErrors) =>
        superagent
            .post(`${API_ROOT}${url}`, body)
            .use(tokenPlugin)
            .use(tokenPlugin2FA)
            .end((e, r) => handleErrors(e, r, skipErrors))
            .then(responseBody),
};

const Auth = {
    current: () => requests.get('/user'),
    loadById: (id) => requests.get(`/user/${id}`),
    config: () => requests.get('/config'),
    login: (email, password) => requests.post('/users/login', { user: { email, password } }),
    loginWith2FAVerificationCode: (verificationCode) => requests.post('/users/login/verify-2fa', { user: { verificationCode } }),
    loginWithSkip2FASetup: (skip2FASetup) => requests.post('/users/login/skip-2fa', { user: { skip2FASetup } }),
    getRecover2FA: () => requests.get('/users/recover-2fa-otp'),
    loginAs: (id) => requests.get(`/users/loginas/${id}`, true),
    save: (user, type = 'basic') => requests.put('/user', { user, type }),
    log: (log) => requests.post('/log', { log }),
    resetPassword: (email) => requests.put('/reset_password', { email }),
    forgotPassword: (email) => requests.post('/users/forgot_password', { email }),
    resetPasswordViaLink: (token, password) => requests.post('/users/reset_password_via_link', { token, password }),
    upload: (images) => requests.post('/images', { images }),
    setLang: (lang) => !!window.sessionStorage.getItem('jwt') ? requests.post('/user/lang', { lang }) : requests.post('/external/lang', { lang }),
    get2FAStatus: () => requests.get('/users/2fa-status'),
    setup2FA: () => requests.post('/users/setup-2fa'),
    enable2FA: (verificationCode, source) => requests.post('/users/enable-2fa', { verificationCode, source }),
    disable2FA: (verificationCode, comment) => requests.post('/users/disable-2fa', { verificationCode, comment }),
    recover2FA: (otp, comment) => requests.post('/users/recover-2fa', { otp, comment }),
};

const BizTypes = {
    list: (params) => requests.get(`/biztypes${convertToGetParams(params)}`),
    load: (id) => requests.get(`/biztypes/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/biztypes/', values) : requests.put(`/biztypes/${values.id}`, values),
    remove: (id) => requests.del(`/biztypes/${id}`),
    getBizTypeDocumentsById: (id) => requests.get(`/biztype_documents/biz/${id}`),
    saveBizTypeDocuments: (data) => requests.post('/biztype_documents', data),
};

const Clients = {
    list: (params) => requests.get(`/clients${convertToGetParams(params)}`),
    load: (id) => requests.get(`/clients/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/clients/', values) : requests.put(`/clients/${values.id}`, values),
    remove: (id) => requests.del(`/clients/${id}`),
    addAttachments: (data) => requests.post('/clients/attachments', data),
    renewClient: (data) => requests.post('/clients/renew', data),
    getMultipleAttachments: (data) => requests.post('/attachments/getmultiple', data),
    getTripleTexToken: (id, data) => requests.put(`/clients/getTripleTexToken/${id}`, data),
    getmultipleAccountsForClient: (id) => requests.get(`/clients/multi_accounts/${id}`),
    saveVismaDetails: (data) => requests.post("/clients/saveVismaDetails", data),
    saveXledgerDetails: (data) => requests.post("/clients/saveXledgerDetails", data),
    getActiveTaskWithMembersForExtraPayments: (_, params) => requests.get(`/clients/getActiveTasksWithMembers${convertToGetParams(params)}`),
    getCompanyShift: () => requests.get("/clients/getCompanyShift/list"),
    getCompanyShiftById: (id) => requests.get(`/clients/getCompanyShift/${id}`),
    saveCompanyShift: (data) => requests.post(`/clients/companyShift`, data),
    editCompanyShift: (id, data) => requests.put(`/clients/companyShift/${id}`, data),
    deleteCompanyShift: (id) => requests.del(`/clients/companyShift/${id}`),
    getOvertimeSetting: () => requests.get(`/clients/overTimeSettings/list`),
    saveOvertimeSetting: (data) => requests.post(`/clients/overTimeSettings`, data),
    editOvertimeSetting: (id, data) => requests.put(`/clients/overTimeSettings/${id}`, data),
    deleteOvertimeSetting: (id) => requests.del(`/clients/overTimeSettings/${id}`),
    saveCompanyShiftOvertime: (data) => requests.post(`/clients/addCompanyShiftOvertime`, data),
    updateCompanyShiftOvertime: (id, data) => requests.put(`/clients/updateCompanyShiftOvertime/${id}`, data),
    deleteCompanyShiftOvertime: (id) => requests.del(`/clients/removeCompanyShiftOvertime/${id}`),
    getHolidayList: (params) => requests.get(`/clients/holidayList${convertToGetParams(params)}`),
    getHolidays: (params) => requests.get(`/clients/holidays${convertToGetParams(params)}`),
    getActiveHolidays: (params) => requests.get(`/clients/activeholidays${convertToGetParams(params)}`),
    saveHolidays: (data) => requests.post(`/clients/saveHolidays`, data),
    getRecommendedHolidays: (params) => requests.get(`/clients/recommendedHolidays${convertToGetParams(params)}`),
    saveRecommendedHolidays: (data) => requests.post(`/clients/saveRecommendedHolidays`, data),
    deleteHoliday: (params) => requests.del(`/clients/deleteHoliday${convertToGetParams(params)}`),
    grantClientApiAccess: (id) => requests.post("/api_key_details", { client_id: id }),
    revokeClientAPIAccess: (id) => requests.del(`/api_key_details/${id}`),
    getClientApiKeys: (id) => requests.get(`/api_key_details/${id}`),
    regenerateClientApiKey: () => requests.post("/api_key_details/generate-api-key"),
    getWorkHoursRule: () => requests.get("/clients/getWorkHoursRule/list"),
    getWorkHoursRuleById: (id) => requests.get(`/clients/getWorkHoursRule/${id}`),
    saveWorkHoursRule: (data) => requests.post(`/clients/workHoursRule`, data),
    editWorkHoursRule: (id, data) => requests.put(`/clients/workHoursRule/${id}`, data),
    deleteWorkHoursRule: (id) => requests.del(`/clients/workHoursRule/${id}`),
    getWorkHoursRuleByDepartment: (department) => requests.get(`/clients/getWorkHoursRuleByDepartment/${department}`),
    validateClientRuleChange: (data, module) => requests.put(`/clients/validateClientRuleChange/${module}`, data),
    importFromExcel: (params) => requests.post(`/import_from_excel/import`, params),
    checkSameFileExists: (params) => requests.get(`/import_from_excel/check_same_file_exists${convertToGetParams(params)}`),
    addAppVersions: (data) => requests.post('/clients/appVersions', data),
    deleteAppVersion: (id) => requests.del(`/clients/appVersions/${id}`),
    getAppVersions: (params) => requests.get(`/clients/appVersions/list${convertToGetParams(params)}`),
    saveIntegrationSettings: (id, data) => requests.post(`/clients/saveIntegrationSettings/${id}`, data),
    getWeeklyOvertimeSettings: () => requests.get('/clients/weeklyOvertimeSettings/list'),
    getWeeklyOvertimeSettingById: (id) => requests.get(`/clients/weeklyOvertimeSettings/${id}`),
    saveWeeklyOvertimeSetting: (data) => requests.post('/clients/weeklyOvertimeSettings', data),
    updateWeeklyOvertimeSetting: (id, data) => requests.put(`/clients/weeklyOvertimeSettings/${id}`, data),
    activationWeeklyOvertimeSetting: (id, data) => requests.put(`/clients/weeklyOvertimeSettings/${id}/activation`, data),
    deleteWeeklyOvertimeMap: (id) => requests.del(`/clients/weeklyOvertimeMap/${id}`),
    saveWeeklyOvertimeMap: (data) => requests.post('/clients/weeklyOvertimeMap', data),
    updateWeeklyOvertimeMap: (id, data) => requests.put(`/clients/weeklyOvertimeMap/${id}`, data),
    getOvertimeCapSettings: () => requests.get('/clients/overtimeCapSetting/list'),
    getOvertimeCapSettingById: (id) => requests.get(`/clients/overtimeCapSetting/${id}`),
    saveOvertimeCapSetting: (data) => requests.post('/clients/overtimeCapSetting', data),
    updateOvertimeCapSetting: (id, data) => requests.put(`/clients/overtimeCapSetting/${id}`, data),
    activationOvertimeCapSetting: (id, data) => requests.put(`/clients/overtimeCapSetting/${id}/activation`, data),
    importTimesheetFromExcel: (data) => requests.post(`/import_from_excel/timelogs`, data),
    update2FASettings: (data) => requests.put('/clients/2fa-settings', data),
    getAdditionalPaymentTasks: (additionalPaymentCode) => requests.get(`/clients/additionalPaymentTasks/${additionalPaymentCode}`),
};

const Users = {
    list: (params) => requests.get(`/admins${convertToGetParams(params)}`),
    load: (id) => requests.get(`/admins/${id}`),
    save: (values, isAdd) => (isAdd ? requests.post('/admins/', values) : requests.put(`/admins/${values.id}`, values)),
    validateDepartmentChange: (id, values) => requests.put(`/admins/validateDepartmentChange/${id}`, values),
    remove: (id) => requests.del(`/admins/${id}`),
    uploadImage: (params) => requests.post('/attachments', params),
    lookupByName: (mode, name, project, includeInactiveUsers) => requests.get(`/admins/lookup_users?name=${name}&mode=${mode}&project=${project}&includeInactiveUsers=${includeInactiveUsers}`),
    sendReport: (params) => requests.get(`/dashboard/send_report${convertToGetParams(params)}`),
    getReportInfo: (params) => requests.get(`/dashboard/report_info${convertToGetParams(params)}`),
    clearNotifications: (params) => requests.get(`/user/clear-notifications_v2${convertToGetParams(params)}`),
    getNotifications: () => requests.get('/user/notifications_v2'),
    gitRev: () => requests.get('/git-rev'),
    validateNewUser: (params) => requests.post('/admins/validate', params),
    validateAddPossible: () => requests.get('/admins/validate_add_possible'),
    increaseUserLimit: () => requests.get('/admins/increase_user_limit'),
    byProjectId: (project_id) => requests.get(`/user/byprojectid/${project_id}`),
    updateAttachmentName: (data) => requests.put('/attachments', data),
    saveInviteUser: (data) => requests.post('/admins/inviteUser', data),
    saveRegisterUser: (params) => requests.get(`/admins/register-user/${convertToGetParams(params)}`),
    getInvitedClientId: (data) => requests.post('/admins/isurl', data),
    saveMember: (data) => requests.post('/admins/register-user', data),
    setActiveInactive: (values) => requests.put(`/admins/setToInactive/${values.id}`, values),
    readNotification: (data) => requests.post('/user/notifications-read', data),
    saveIntoIntegration: (values) => requests.put(`/admins/saveIntoIntegration/${values.id}`, values),
    desyncIntegration: (values) => requests.put(`/admins/desyncIntegration/${values.id}`, values),
    refetchFromIntegration: (values) => requests.put(`/admins/refetchFromIntegration/${values.id}`, values),
    checkIfValidLink: (id) => requests.get(`/user/checkUserLink/${(id)}`),
    setSecurePassword: (data) => requests.post('/user/password_setup', data),
    getDepartmentForIntegration: () => requests.get('/admins/getTripletexDepartmentForTripletex'),
    resetUserSickLeaveStartDate: (data) => requests.post('/user/reset_sick_leave_start_date', data),
    getAllEmployeeFromIntegration: (params) => requests.get(`/admins/getAllEmployeeFromIntegration${convertToGetParams(params)}`),
    saveMemberFromIntegration: (data) => requests.post(`/admins/saveMemberFromIntegration`, data),
    getUsersWithGroup: () => requests.get(`/admins/getUsersWithGroup`),
    getPmMembersToAssign: (pm_id) => requests.get(`/users/member-to-assign-to-pm/${pm_id}`),
    assignMembersToPm: (pm_id, data) => requests.put(`/admins/assign-members-to-pm/${pm_id}`, data),
    getUserPermissions: (user_id) => requests.get(`/user_access_rules/${user_id}`),
    setUserPermissions: (data) => requests.post(`/user_access_rules`, data),
    loadUsersWithPermissions: (params) => requests.get(`/user_access_rules/users-with-permissions${convertToGetParams(params)}`),
    bulkSaveRosterPermissions: (data) => requests.post(`/user_access_rules/bulk-update-permissions`, data),
    getCostUnitsAndTypes: (params) => requests.get(`/admins/getCostUnitsAndTypes${convertToGetParams(params)}`),
    refetchWagetypes: () => requests.get('/admins/refetchWagetypes'),
    refetchMetaData: () => requests.get('/admins/refetchMetaData'),
    getIntegrationMetaData: (params) => requests.get(`/admins/getIntegrationMetaData${convertToGetParams(params)}`),
    updateUserProfileOnBasisOfGroups: (data) => requests.post('/admins/addExtraPaymentToUserProfile', data),
    lookupPms: () => requests.get('/admins/lookup_pms'),
    getUserManagers: (params) => requests.get(`/admins/user_managers/${params.userId}${convertToGetParams(params)}`),
    assignPmToUser: (id, pm_ids) => requests.post(`/admins/assign_pm/${id}`, { pm_ids }),
    deleteUserPm: (userId, pmId) => requests.del(`/admins/assign_pm/${userId}/${pmId}`),
    getPmsForUser: (params) => requests.get(`/admins/userPmsList/${params.userId}${convertToGetParams(params)}`),
    pmsForUserCount: (params) => requests.get(`/admins/userPmsList/count/${params.userId}${convertToGetParams(params)}`),
    lookupPmMembers: (params) => requests.get(`/v2/admin/lookup_pm_members${convertToGetParams(params)}`),
    getProjectsForUser: (params) => requests.get(`/admins/userProjectsList/${params.userId}${convertToGetParams(params)}`),
    saveProjectMembers: (data) => requests.post(`/admins/saveProjectMembers/${data.userId}`, data),
    bulkAssignProjectsToUsers: (data) => requests.post(`/admins/bulkAssignProjectsToUsers`, data),
    bulkUpdateUserField: (data) => requests.post(`/users/bulkUpdateUserField`, data),
    bulkUpdateUserFieldConfig: () => requests.get(`/users/bulkUpdateUserFieldConfig`),
    usersList: (params) => requests.get(`/users/usersList${convertToGetParams(params)}`),
    usersFieldCount: (params) => requests.get(`/users/usersFieldCount${convertToGetParams(params)}`),
    getAvailableAbsenceTypesForUser: (userId) => requests.get(`/users/${userId}/available-absence-types`),
    getUserLeaveTypeGrants: (userId) => requests.get(`/users/${userId}/leave-type-grants`),
    saveUserLeaveTypeGrants: (userId, codes) => requests.post(`/users/${userId}/leave-type-grants`, { codes }),
    projectsForUserCount: (params) => requests.get(`/admins/userProjectsList/count/${params.userId}${convertToGetParams(params)}`),
    deleteProjectMember: (params) => requests.del(`/projects/list/deleteProjectMember/${convertToGetParams(params)}`), //used same api from project because both are same
    getPmMembers: (params) => requests.get(`/admins/list/pmMembersList/${params.id}${convertToGetParams(params)}`),
    savePmMembers: (data) => requests.post(`/admins/savePmMembers/${data.id}`, data),
    pmUserCount: (params) => requests.get(`/admins/pmMembersList/count/${params.id}${convertToGetParams(params)}`),
    deletePmMember: (params) => requests.del(`/admins/list/deletePmMember/${convertToGetParams(params)}`),
    getUserWeeklyOvertimeMap: (user_id) => requests.get(`/users/user-weekly-overtime-map/${user_id}`),
    saveUserWeeklyOvertimeMap: (data) => requests.post("/users/user-weekly-overtime-map", data),
    deactivateUserWeeklyOvertimeMap: (id) => requests.put(`/users/user-weekly-overtime-map/${id}`),
    batchDeactivateUserWeeklyOvertimeMap: (data) => requests.put("/users/user-weekly-overtime-map/batch-deactivate", data),
    batchDeactivateUserOvertimeCapMap: (data) => requests.put("/users/user-overtime-cap-map/batch-deactivate", data),
    getUserOvertimeCapMap: (user_id) => requests.get(`/users/user-overtime-cap-map/${user_id}`),
    saveUserOvertimeCapMap: (data) => requests.post("/users/user-overtime-cap-map", data),
    deactivateUserOvertimeCapMap: (id) => requests.put(`/users/user-overtime-cap-map/${id}`),
    getUserTimesheetBlocks: (user_id) => requests.get(`/users/timesheet_block/${user_id}`),
    saveUserTimesheetBlock: (data) => requests.post("/users/timesheet_block/", data),
    unblockUserTimesheet: (id) => requests.put(`/users/timesheet_block/${id}`),
    get2FAList: (params) => requests.get(`/users/2fa-list${convertToGetParams(params)}`),
    get2FAHistory: (userId, params) => requests.get(`/users/2fa-history/${userId}${convertToGetParams(params)}`),
    recover2FAByAdmin: (data) => requests.post('/users/recover-2fa-by-admin', data),
};

const UserGroups = {
    getGroupByUserAndUsageDetails: () => requests.get('/user_group_details'),
    getGroupDetails: (params) => requests.get(`/user_group_details/get_group_details${convertToGetParams(params)}`),
    getUserGroups: (user_id) => requests.get(`/user_group_details/get_user_groups/${user_id}`),
    getUsersInGroup: (user_group_code) => requests.get(`/user_group_details/get_users_in_group/${user_group_code}`),
    checkIfGroupInUse: (user_group_code) => requests.get(`/user_group_details/check_user_group_usage/${user_group_code}`),
    addUserGroupAndAssignMembers: (data) => requests.post('/user_group_details/add_user_group_and_assign_members', data),
    updateUserGroupAndAssignees: (data) => requests.put('/user_group_details/update_user_group_and_assignees', data),
    removeGroup: (id) => requests.del(`/user_group_details/${id}`),
}

const PermissionGroups = {
    getGroups: (params) => requests.get(`/permission_groups${convertToGetParams(params)}`),
    getAssignableUsers: (params) => requests.get(`/permission_groups/assignable_users${convertToGetParams(params)}`),
    createGroup: (data) => requests.post('/permission_groups', data),
    updateGroup: (id, data) => requests.put(`/permission_groups/${id}`, data),
    saveGroupMembers: (id, data) => requests.put(`/permission_groups/${id}/members`, data),
    applyGroup: (id, data) => requests.post(`/permission_groups/${id}/apply`, data),
    removeGroup: (id) => requests.del(`/permission_groups/${id}`),
}

const Signature = {
    createCaseID: (data) => requests.post(`/sign_documents`, data),
    uploadDocs: (data) => requests.post(`/sign_documents/addDocument`, data),
    deleteDocs: (doc_id) => requests.del(`/sign_documents/removeDocument/${encodeURIComponent(doc_id)}`),
    fetchAllDocs: (case_id) => requests.get(`/sign_documents/getById/${encodeURIComponent(case_id)}`),
    updateDocName: (data) => requests.post('/sign_documents/updateDocumentName', data),
    deleteDocPage: (id) => requests.del(`/sign_documents/removeDocumentPage/${id}`),
    signDocHistory: (params) => requests.get(`/sign_doc_history/getById/${convertToGetParams(params)}`),
    addWidgets: (data) => requests.post(`/sign_documents/addWidgetsData`, data),
    createDocument: (params) => requests.get(`/sign_documents${convertToGetParams(params)}`),
    sendDocNow: (data) => requests.post(`/sign_documents/review_send`, data),
    getRecipientDoc: (id) => requests.get(`/sign_documents/getDocument/${encodeURIComponent(id)}`),
    recipientAgreement: (data) => requests.post(`/recipient_agreements`, data),
    getByDocCaseId: (id) => requests.get(`/sign_documents/getByDocCaseId/${encodeURIComponent(id)}`),
    storeSignature: (data) => requests.post('/recipient_signs', data),
    downloadPdf: (id) => requests.get(`/sign_documents/download/${encodeURIComponent(id)}`),
    generateSignatureLink: (id) => requests.get(`/sign_documents/create_signature_link/${encodeURIComponent(id)}`),
    downloadCompletedDocument: (id) => requests.get(`/sign_documents/completed_signing_document/${encodeURIComponent(id)}`),
    verifyAccessCode: (data) => requests.post(`/sign_documents/verify_access_code`, data),
    deleteSignatureDoc: (case_id) => requests.del(`/sign_documents/${encodeURIComponent(case_id)}`)
}

const Dashboard = {
    get: (params) => requests.get(`/v2/dashboard${convertToGetParams(params)}`),
    getSchedules: (params) => requests.get(`/v2/dashboard/schedules${convertToGetParams(params)}`),
    getDeviations: () => requests.get("/v2/dashboard/deviations"),
    contact: (params) => requests.put('/contact_email', params),
};

const Projects = {
    list: (params) => requests.get(`/v2/projects${convertToGetParams(params)}`),
    load: (id) => requests.get(`/projects/${id}`),
    getProjectMembersIds: (id) => requests.get(`/projects/projectmemberids/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/projects/', values) : requests.put(`/projects/${values.id}`, values),
    remove: (id, confirm) => requests.del(`/projects/${id}?confirm=${confirm}`),
    lookupByName: (params) => requests.get(`/v2/projects/lookup${convertToGetParams(params)}`),
    lookupPmByName: (params) => requests.get(`/v2/projects/lookup_pm_schedule${convertToGetParams(params)}`),
    saveIntoIntegration: (values) => requests.put(`/projects/saveIntoIntegration/${values.id}`, values),
    getAllProjectFromIntegration: (params) => requests.get(`/projects/getAllProjectFromIntegration${convertToGetParams(params)}`),
    getProjectsTaskFromIntegration: (params) => requests.get(`/projects/getProjectsTaskFromIntegration${convertToGetParams(params)}`),
    saveProjectFromIntegration: (data) => requests.post(`/projects/saveProjectFromIntegration`, data),
    saveProjectFromIntegrationXledger: (data) => requests.post(`/projects/saveProjectFromIntegrationXledger`, data),
    saveProjectFromIntegrationVisma: (data) => requests.post(`/projects/saveProjectFromIntegrationVisma`, data),
    getProjectPmShiftPermissions: (id) => requests.get(`/project_pm_rules/${id}`),
    getProjectPmList: (id) => requests.get(`/v2/projects/pm_list/${id}`),
    toggleProjectFavorite: (id) => requests.post(`/v2/projects/toggle_favorite/${id}`, {}),
    setProjectPmShiftPermissions: (data) => requests.post('/project_pm_rules', data),
    sendInviteToContactPerson: (data) => requests.post('/projects/inviteToContactPerson', data),
    projectMemberLookup: (projectId, params) => requests.get(`/v2/projects/lookup_members/${projectId}${convertToGetParams(params)}`),
    getProjectTotals: () => requests.get('/v2/projects/project_totals'),
    getProjectTotalHours: (id, params) => requests.get(`/v2/projects/project_total_hours/${id}${convertToGetParams(params)}`),
    saveProjectMembers: (values) => requests.post(`/projects/saveProjectMembers/${values.projectId}`, values),
    getProjectMembers: (params) => requests.get(`/projects/list/projectMembers${convertToGetParams(params)}`),
    getProjectMembersCount: (params) => requests.get(`/projects/projectMembers/count/${params.projectId}${convertToGetParams(params)}`),
    deleteProjectMember: (params) => requests.del(`/projects/list/deleteProjectMember/${convertToGetParams(params)}`),
    getIntegrationProjectsCount: (params) => requests.get(`/projects/list/getIntegrationProjectsCount${convertToGetParams(params)}`)
};

const Tasks = {
    list: (params) => requests.get(`/v2/tasks${convertToGetParams(params)}`),
    load: (id) => requests.get(`/tasks/${id}`),
    save: (values, isAdd) => (isAdd ? requests.post('/tasks', values) : requests.put(`/tasks/${values.id}`, values)),
    remove: (id, isSelf) => requests.del(`/tasks/${id}/${isSelf}`),
    lookupByName: (projectId, params) => requests.get(`/v2/tasks/lookup/${projectId}${convertToGetParams(params)}`),
    loadMembersForTask: (taskId, params) => requests.get(`/v2/tasks/lookup_members/${taskId}${convertToGetParams(params)}`),
    gpsAddress: (address, taskId, isFromTask) => requests.get(`/tasks/geolocation?address=${encodeURI(address)}&isFromTask=${isFromTask}&changeId=${taskId}`),
    getTaskToClone: (id) => requests.get(`/tasks/${id}/getAllTasks`),
    cloneTasks: (data) => requests.post('/tasks/cloneTasks', data),
    saveIntoIntegration: (values) => requests.put(`/tasks/saveIntoIntegration/${values.id}`, values),
    saveTaskFromIntegration: (data) => requests.post(`/tasks/saveTaskFromIntegration`, data),
    saveTaskInBulkFromIntegration: (data) => requests.post(`/tasks/saveTaskInBulkFromIntegration`, data),
    getTaskTotals: () => requests.get('/v2/tasks/tasks_totals'),
    getTaskTotalHours: (id, params) => requests.get(`/v2/tasks/tasks_total_hours/${id}${convertToGetParams(params)}`),
    toggleTaskFavorite: (id) => requests.post(`/v2/tasks/toggle_favorite/${id}`, {}),
    saveTaskMembers: (values) => requests.post(`/tasks/saveTaskMembers/${values.taskId}`, values),
    getTaskMembersFromProjectMembers: (params) => requests.get(`/tasks/list/taskMembersList${convertToGetParams(params)}`),
    getTaskMembersFromProjectCount: (params) => requests.get(`/tasks/taskMembers/count/${params.taskId}${convertToGetParams(params)}`),
    deleteTaskMember: (params) => requests.del(`/tasks/taskMember${convertToGetParams(params)}`),
    getTasksFromIntegration: (params) => requests.get(`/tasks/list/getTasksFromIntegration${convertToGetParams(params)}`),
    saveTasksFromIntegrationTripletex: (data) => requests.post(`/tasks/saveTasksFromIntegrationTripletex`, data),

};

const Chat = {
    loadRooms: () => requests.get('/chat/rooms'),
    loadRoom: (id) => requests.get(`/chat/room/${id}`),
    loadMessages: (id) => requests.get(`/chat/messages/${id}`),
    createPrivateRoom: (data) => requests.post(`/chat/privaterooms`, data),
    loadPrivateRooms: () => requests.get('/chat/privaterooms'),
    loadPrivateRoom: (id) => requests.get(`/chat/privateroom/${id}`),
    saveRoom: (values, isAdd) =>
        isAdd ? requests.post('/chat/rooms', values) : requests.put(`/chat/room/${values.room.id}`, values),
    removeRoom: (id) => requests.del(`/chat/rooms/${id}`),
    removePrivateRoom: (id) => requests.del(`/chat/${id}`)
};

const Recipients = {
    list: (params) => requests.get(`/recipients${convertToGetParams(params)}`),
    save: (values) => requests.post('/recipients/', values),
    fetchAllRecipients: (id) => requests.get(`/recipients/getByCaseId/${encodeURIComponent(id)}`)
}


const Timelogs = {
    list: (params) => requests.get(`/v3/timelogs${convertToGetParams(params)}`),
    load: (id) => requests.get(`/timelogs/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/v3/timelogs/', values) : requests.put(`/timelogs/${values.id}`, values),
    quickTimeUpdate: (values) => requests.put(`/v3/timelogs/quickTimeUpdate/${values.id}`, values),
    remove: (id) => requests.del(`/timelogs/${id}`),
    // saveHolidays: (values) => requests.post('/timelogs/holidays', values),
    setStatus: (entityName, id, data) => requests.put(`/timelogs/status/${entityName}/${id}`, data),
    setMedicalLeaveMassStatus: (id, data) => requests.put(`/timelogs/mass_status/absence/${id}`, data),
    presenceList: (params) => requests.get(`/presences${convertToGetParams(params)}`),
    getDraftId: (autostart) => requests.get(`/timelogs/draft_id${convertToGetParams(autostart || {})}`),
    getDraftTimelog: () => requests.get(`/v3/timelogs/draft_id`),
    getCurrentDraftOrSkip: (forceProject, user, onlyValid) =>
        requests.get(
            `/timelogs/current_draft_or_skip?forceProject=${forceProject}&user=${user}&onlyValid=${onlyValid}`
        ),
    getCurrentDraftForLocked: (forceProject, user) =>
        requests.get(`/timelogs/current_draft_for_locked?project=${forceProject}&user=${user}`),
    finishByButton: (id, data) => requests.put(`/timelogs/finish/${id}`, data || {}),
    reportInjury: (id, isInjury) => requests.put(`/v3/timelogs/reportInjury/${id}/${isInjury}`),
    breakByButton: (id, action) => requests.put(`/timelogs/break/${id}/${action}`, {}),
    startByButton: (data) => requests.put(`/v3/timelogs/start`, data),
    getAllLocations: (params) => requests.get(`/timelogs/all_locations${convertToGetParams(params)}`),
    sendMassStatusPushNotification: (userId, comment, action) => requests.post(`/timelogs/multiplePush/${userId}`, { comment, action }),
    sendSingleStatusPushNotification: (timelogId, comment, action, syncWithIntegration) => requests.post(`/timelogs/singlePush/${timelogId}`, { comment, action, syncWithIntegration }),
    addTip: (data) => requests.post(`/timelogs/addtip`, data),
    getTipList: (params) => requests.get(`/timelogs/tip${convertToGetParams(params)}`),
    deleteTip: (id) => requests.del(`/timelogs/tip/${id}`),
    updateTip: (id, data) => requests.put(`/timelogs/tip/${id}`, data),
    validateTimelogWithIntegration: (values) => requests.post('/timelogs/validateTimelogWithIntegration', values),
    cancelPendingAbsenceOrVacation: (link) => requests.put(`/${link}`),
    forDateList: (user_id, for_date) => requests.get(`/timelogs/getMultiTaskTimelogs/${user_id}/${for_date}`),
    forDateIntList: (user_id, for_date) => requests.get(`/timelogs/payrollDetails/${user_id}/${for_date}`),
    multiTimelogStatus: (value) => requests.post(`/v2/timelogs/multiTimelogStatus`, value),
    updateTimesheetToManuallyManagedMode: (id, type) => requests.put(`/v2/timelogs/updateTimelogToMandatoryOvertime/${id}`, { type }),
    saveOvertimeComment: (id, overtime_comment) => requests.put(`/v3/timelogs/overtimeComment/${id}`, { overtime_comment }),
    startTimelogAsMandatory: (id, data) => requests.put(`/v2/timelogs/startTimelogAsMandatory/${id}`, data),
    convertMandatoryTimelogToNormal: (id) => requests.put(`/v2/timelogs/convertMandatoryTimelogToNormal/${id}`),
    removeMandatoryOvertimeFlexitime: (id) => requests.put(`/v2/timelogs/removeMandatoryOvertimeFlexitime/${id}`),
    validateTimelogAndReset: (id) => requests.post(`/v2/timelogs/validateTimelogAndReset/${id}`),
    employeeConfirm: (data) => requests.put(`/v3/timelogs/employeeConfirm`, data),
    getTimelogConflicts: (params) => requests.put(`/v3/timelogs/conflicts/checkConflict${convertToGetParams(params)}`),
    getUserShiftDetails: (userId, date, shiftId) => requests.get(`/v3/timelogs/userShiftDetails/${userId}/${date}${shiftId ? `?shiftId=${shiftId}` : ''}`),
};

const Vacations = {
    list: (params) => requests.get(`/vacations${convertToGetParams(params)}`),
    load: (id) => requests.get(`/vacations/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/vacations/', values) : requests.put(`/vacations/${values.id}`, values),
    remove: (id, data) => requests.del(`/vacations/${id}`, data),
    deleteCarryForwardVacation: (id) => requests.del(`/vacations/carryforward/${id}`),
    cancelVacation: (id, data) => requests.put(`/vacations/cancel/${id}`, data),
    getHoldProjectList: () => requests.get('/vacations/hold-project'),
    getHoldProjectRosters: (userIds, fromDate, toDate) => requests.get(`/vacations/hold-project/rosters${convertToGetParams({ userIds: userIds.join(','), from_date: fromDate, to_date: toDate })}`),
    getHoldProjectWorkPatternAssignments: (ids) => requests.get(`/vacations/hold-project/work-pattern-assignments${convertToGetParams({ ids: ids.join(',') })}`),
    applyHoldProject: (values) => requests.post('/vacations/hold-project', values),
    revertHoldProject: (id, memberIds) => requests.post(`/vacations/hold-project/${id}/revert`, { member_ids: memberIds }),
    revertHoldForIndividually: (vacationId) => requests.post(`/vacations/${vacationId}/revert-hold`),
};

const Absences = {
    list: (params) => requests.get(`/absences${convertToGetParams(params)}`),
    load: (id) => requests.get(`/absences/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/absences/', values) : requests.put(`/absences/${values.id}`, values),
    remove: (id, data) => requests.del(`/absences/${id}`, data),
    getAbsenceTotals: (params) => requests.get(`/absences/absenceTotals${convertToGetParams(params)}`),
    getChildrenDetails: (id) => requests.get(`/absences/childrenDetails/${id}`),
    cancelAbsence: (id, data) => requests.put(`/absences/cancel/${id}`, data),
    saveCompOff: (values) => requests.post('/absences/saveCompOff', values),
    getAbsenceStatusCounts: () => requests.get('/absences/absence_status_counts'),
};

const Deviation = {
    list: (params) => requests.get(`/deviations${convertToGetParams(params)}`),
    load: (id) => requests.get(`/deviations/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/deviations/', values, true) : requests.put(`/deviations/${values.id}`, values, true),
    remove: (id) => requests.del(`/deviations/${id}`),
    transition: ({ id, transitionName, transitionData }) =>
        requests.put(`/deviations/${id}/transition/${transitionName}`, transitionData, true),
    sendEmail: (id, email) => requests.put(`/deviations/${id}/email`, { email }, true),
};

const ExtraDoc = {
    list: (params) => requests.get(`/extradocs${convertToGetParams(params)}`),
    load: (id) => requests.get(`/extradocs/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/extradocs/', values, true) : requests.put(`/extradocs/${values.id}`, values, true),
    remove: (id) => requests.del(`/extradocs/${id}`),
};

const Locked = {
    startLock: (data) => requests.post('/locked/pm?start=true', data, true),
    endLock: (data) => requests.post('/locked/pm?start=false', data, true),
    loginWithPin: (data) => requests.post('/locked/loginwithpin', data, true),
    loadList: (params) => requests.get(`/locked/list${convertToGetParams(params)}`),
    sendReportByMail: (params) => requests.get(`/locked/send${convertToGetParams(params)}`),
    sendSms: (params) => requests.get(`/locked/sendsms${convertToGetParams(params)}`, true),
};

const Schedule = {
    list: (params) => requests.get(`/v2/schedule${convertToGetParams(params)}`),
    availabilityList: (params) => requests.get(`/availability/get-table${convertToGetParams(params)}`),
    load: (id) => requests.get(`/schedule/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/schedule/', values) : requests.put(`/schedule/${values.id}`, values),
    getAvailableAssignees: (id) => requests.get(`/schedule/${id}/available_assignees`),
    sendSwapShiftRequest: (users) => requests.post('/schedule/send_swap_request', users),
    getSwapShiftRequests: (swap_id) => requests.get(`/schedule/swap_shift_requests`, { swap_id: swap_id }),
    getSwapShiftRequestsForPM: (params) => requests.get(`/schedule/swap_shift_requests_approval${convertToGetParams(params)}`),
    acceptSwapShiftRequests: (data) => requests.post(`/schedule/swap_accepted`, data),
    rejectSwapShiftRequests: (data) => requests.post(`/schedule/swap_rejected`, data),
    approveOrRejectSwapShiftRequestsFromPM: (data) => requests.post('/schedule/shift_swap_approve_or_reject', data),
    approveOrRejectTradeShiftRequestsFromPM: (data) => requests.post('/schedule/shift_trade_approve_or_reject', data),
    addBulkShift: (values) => requests.post('/schedule/bulk-shift/', values),
    addRosterShift: (data) => requests.post('/schedule/roster-shift/', data),
    getMemberRosterTemplates: (params) => requests.get(`/schedule/member-roster-templates${convertToGetParams(params)}`),
    remove: (id, params) => requests.del(`/schedule/${id}${convertToGetParams(params)}`),
    loadResources: (params) => requests.get(`/v2/schedule/resources_v2${convertToGetParams(params)}`),
    move: (data) => requests.put('/schedule/move', data),
    copy: (data) => requests.put('/schedule/copy', data),
    listWeekly: () => requests.get('/schedule/weekly'),
    copyMonth: (data) => requests.put('/schedule/copy_month', data),
    memberAction: (id, action, data) => requests.put(`/schedule/${id}/memberaction/${action}`, data),
    removeMultiple: (id, params) => requests.del(`/schedule/multi_delete/${id}${convertToGetParams(params)}`),
    sendNotify: (values) => requests.post('/availability/sendnotifications/', values),
    updateAvailabilityStatus: (id, data) => requests.put(`/availability/update-status/${id}`, data),
    removeAvailability: (id) => requests.del(`/availability/${id}`),
    updateStatus: (id, data) => requests.put(`/availability/${id}`, data),
    saveAvailability: (values) => requests.post('/availability/', values),
    getAvailability: (values) => requests.get(`/availability/${convertToGetParams(values)}`),
    hideShowShifts: (values) => requests.post(`/schedule/hide_show_shifts`, values),
    getWeekHeader: (params) => requests.get(`/schedule/currentWeekHeader${convertToGetParams(params)}`),
    overwriteOrRevertShiftChanges: (data) => requests.put('/schedule/overwrite_shifts', data),
    getShiftsAndAssignees: (params) => requests.get(`/schedule/get_shifts_and_assignees${convertToGetParams(params)}`),
    getAvailableAssigneesForBulkShift: () => requests.get('/v2/schedule/getAvailableAssigneesForBulkShift'),
    approveTimesheets: (data) => requests.post('/v2/schedule/approve-timelogs', data),
    loadShiftsForApproval: (params) => requests.get(`/v2/schedule/load-shifts${convertToGetParams(params)}`),
    updateSystemTimesheet: (data) => requests.post('/v2/schedule/update-system-timesheet', data),
    approveShifts: (id) => requests.put(`/schedule/approve_shifts/${id}`),
    toggleAutoTimesheet: (id, value) => requests.put(`/schedule/${id}`, { allow_shift_for_auto_timesheet: value }),
    getRecurringShifts: (params) => requests.get(`/v2/recurring_shifts${convertToGetParams(params)}`),
    getRecurringShiftHistory: (id, params) => requests.get(`/v2/recurring_shifts/${id}/history${convertToGetParams(params)}`),
    saveRecurringShift: (values, isAdd) =>
        isAdd ? requests.post('/v2/recurring_shifts', values) : requests.put(`/v2/recurring_shifts/${values.id}`, values),
    removeRecurringShift: (id) => requests.del(`/v2/recurring_shifts/${id}`),
};

const checklist = {
    listelementbyclientid: (params) => requests.get(`/elements/client`),
    addelement: (data) => requests.post('/elements', data, true),
    getElementById: (id) => requests.get(`/elements/${id}`),
    deleteElementById: (id) => requests.post(`/elements/delete/${id}`),
    getMultipleAttachments: (data) => requests.post('/attachments/getmultiple', data),

    searchElement: (data) => requests.post('/elements/search', data, true),
    getElementChildByParentId: (data) => requests.post('/elements/child', data, true),
    copyElementById: (data) => requests.post('/elements/copy', data, true),

    getChecklistTemplateByClientId: (params) => requests.get(`/checklists${convertToGetParams(params)}`),
    getChecklistTemplateByClientIdPagination: (params) => requests.get(`/elements/cpage/${convertToGetParams(params)}`),
    addChecklistTemplate: (data) => requests.post('/checklists', data, true),
    getChecklistTemplateById: (id) => requests.get(`/checklists/${id}`),
    deleteChecklistTemplateById: (id) => requests.del(`/checklists/${id}`),
    deleteChecklistById: (id) => requests.del(`/userchecklists/${id}`),
    assignChecklist: (data) => requests.post('/userchecklists/assign', data, true),
    scheduleToNone: (data) => requests.post('/userchecklists/scheduleToNone', data, true),
    getChecklistById: (id) => requests.get(`/userchecklists/get/${id}`),
    lookupByName: (data) => requests.post(`/checklists/lookup_checklist`, data, true),
    getChecklists: (params) => requests.get(`/v2/userchecklists${convertToGetParams(params)}`),
    getChecklistsIsSchedule: (params) => requests.get(`/userchecklists/isSchedule${convertToGetParams(params)}`),
    checkChecklistElement: (data) => requests.post(`/userchecklists/check`, data, true),
    checkAllChecklist: (data) => requests.post(`/userchecklists/checkall`, data, true),
    approveChecklist: (data) => requests.post('/userchecklists/approve', data, true),
    report: (type) => requests.post(`/userchecklists/report/${type}`),
    deviationChecklist: (data) => requests.post('/userchecklists/deviation', data, true),
}

const documents = {
    //HTTP methods for documents//
    getDocuments: (params) => requests.get(`/documents/page${convertToGetParams(params)}`),
    getDocumentsList: (params) => requests.get(`/documents/list`),
    getDocumentById: (id) => requests.get(`/documents/getById/${id}`),
    addDocument: (data) => requests.post('/documents', data, true),
    copyDocument: (data) => requests.post('/documents/copy', data, true),
    deleteDocumentById: (id) => requests.del(`/documents/${id}`),
    getTemplateDocuments: (params) => requests.get(`/documents/getTemplateDocs${convertToGetParams(params)}`),
    getAdminDocuments: (params) => requests.get(`/documents/admin/list`),
    getPDFDataByAttachmentId: (id) => requests.get(`/attachments/filedata/${id}`),

    //HTTP methods for document_template//
    getDocumentTemplates: (params) => requests.get(`/document_templates${convertToGetParams(params)}`),
    getDocumentTemplateById: (id) => requests.get(`/document_templates/getById/${id}`),
    addDocumentTemplate: (data) => requests.post('/document_templates', data, true),
    deleteDocumentTemplateById: (id) => requests.del(`/document_templates/${id}`),
    getDocumentsInTemplate: (id) => requests.get(`/document_templates/getDocs/${id}`),
    getDocumentsInTemplateInSelectedOrder: (id) => requests.get(`/document_templates/getDocsByOrder/${id}`),
    getMultipleDoumentsByIds: (params) =>
        requests.get(`/document_templates/getMultipleDoumentsByIds${convertToGetParams(params)}`),
    getDocumentReportByTemplateId: (id) => requests.get(`/document_templates/report/${id}`),
    getDocumentReportPreviewByTemplateId: (id) => requests.get(`/document_templates/reportPreview/${id}`),
    getmultipleDocumentsPdfPreviewUrl: (params) =>
        requests.get(`/document_templates/multipleDocumentsPdfPreview${convertToGetParams(params)}`),
    getDocumentTemplateAssignList: (id) => requests.get(`/document_templates/getTemplateAssignList/${id}`),

    //HTTP methods for document_read//
    addDocumentRead: (data) => requests.post('/document_read', data),
    sendDocumentReadMailToMembers: (data) => requests.post('/document_read/sendMailsToMembers', data),
    updateDocumentReadStatus: (data) => requests.post('/document_read/edit', data),
    assignDocumentTemplatesToUser: (data) => requests.post('/document_read/assignDocumentTemplatesToUser', data),
};

const visitors = {
    //HTTP methods for visitors//
    getVisitors: (params) => requests.get(`/visitors${convertToGetParams(params)}`),
    getVisitorsReport: (params) => requests.get(`/visitors/report${convertToGetParams(params)}`),
    getVisitorById: (id) => requests.get(`/visitors/getById/${id}`),
    addVisitor: (data) => requests.post('/visitors', data, true),
    addVisitorPublic: (data) => requests.post('/visitors/visitorRegister', data, true),
    addClientVisitorPublic: (data) => requests.post('/visitors/visitorClientRegister', data, true),
    verifyClientVisitor: (data) => requests.post('/visitors/verifyClientRegister', data, true),
    deleteVisitorById: (id) => requests.del(`/visitors/${id}`),
    // zones (admin)
    getZones: () => requests.get('/visitors/zones'),
    saveZone: (data) => requests.post('/visitors/zones', data, true),
    deleteZone: (id) => requests.del(`/visitors/zones/${id}`),
    // safety rules (admin)
    getSafetyRules: (params) => requests.get(`/visitors/safety-rules${convertToGetParams(params)}`),
    saveSafetyRule: (data) => requests.post('/visitors/safety-rules', data, true),
    deleteSafetyRule: (id) => requests.del(`/visitors/safety-rules/${id}`),
    // visitor logs (admin)
    getVisitorLogs: (params) => requests.get(`/visitors/logs${convertToGetParams(params)}`),
    getVisitorLogById: (id) => requests.get(`/visitors/logs/${id}`),
    approveVisitorLog: (id, data) => requests.post(`/visitors/logs/${id}/approve`, data, true),
    rejectVisitorLog: (id, data) => requests.post(`/visitors/logs/${id}/reject`, data, true),
    pmReviewVisitorLog: (id, data) => requests.post(`/visitors/logs/${id}/pm-review`, data, true),
    checkoutVisitorLog: (id) => requests.post(`/visitors/logs/${id}/checkout`, {}, true),
    deleteVisitorLog: (id) => requests.del(`/visitors/logs/${id}`),
    downloadVisitorPass: (id) => {
        const token = commonStore.token;
        window.open(`${API_ROOT}/visitors/logs/${id}/pass?authorization=${token}&lang=${sessionStorage.getItem('locale') || 'en'}`, '_blank');
    },
    getRegisterLink: () => requests.get('/visitors/register-link'),

    // public multi-step registration (no auth)
    getPublicZones: (enc) => requests.get(`/visitors/public/zones/${enc}`),
    getPublicSafetyRules: (enc, zoneId) => requests.get(`/visitors/public/safety-rules/${enc}/${zoneId}`, true),
    getPublicEmployees: (enc) => requests.get(`/visitors/public/employees/${enc}`, true),
    getPublicPmEmployees: (enc) => requests.get(`/visitors/public/employees/${enc}?role=pm`, true),
    searchPublicEmployees: (enc, q) => requests.get(`/visitors/public/employees/search/${enc}?q=${encodeURIComponent(q)}`, true),
    publicRegister: (enc, data) => requests.post(`/visitors/public/register/${enc}`, data, true),
    getPublicRegistrationQr: (enc) => requests.get(`/visitors/public/registration-qr/${enc}`, true),
    getPublicLogStatus: (id) => requests.get(`/visitors/public/log/${id}/status`),
    checkPublicDuplicate: (enc, email, phone, date) => requests.get(`/visitors/public/check-duplicate/${enc}?email=${encodeURIComponent(email || '')}&phone=${encodeURIComponent(phone || '')}&date=${encodeURIComponent(date || '')}`, true),
};

const contracts = {
    getContractTypes: (params) => requests.get(`/contract_types${convertToGetParams(params)}`),
    getContractTypesById: (id) => requests.get(`/contract_types/getById/${id}`),
    addContractType: (data) => requests.post('/contract_types', data, true),
    UpdateContractType: (data) => requests.put(`/contract_types/`, data),
    deleteContractById: (id) => requests.del(`/contract_types/${id}`),
    loadEditorDataById: (id) => requests.get(`/contract_documents/getById/${id}`),
    saveEditorData: (data) => requests.post('/contract_documents/', data),
    saveContractArchives: (data) => requests.post(`/contract_archives`, data),
    getPDFData: (id) => requests.get(`/contract_archives/getById/${id}`),
    archivesPDFDownload: (id) => requests.get(`/contract_archives/download/${id}`)
};

const contractslist = {
    getContractsData: (params) => requests.get(`/contracts${convertToGetParams(params)}`),
    getContractsById: (id) => requests.get(`/contracts/${id}`),
    addContractData: (data) => requests.post('/contracts', data, true),
    deleteContractsData: (id) => requests.del(`/contracts/${id}`),
    UpdateContracts: (data) => requests.put(`/contracts/`, data),
    //   UpdateContracts: (values, isAdd) =>
    //   isAdd ? requests.post('/contracts/', values) : requests.put(`/contracts/${values.id}`, values)
}

const Monitor = {
    list: (params) => requests.get(`/monitor${convertToGetParams(params)}`),
    load: (id) => requests.get(`/monitor/${id}`),
    save: (data) => requests.post('/monitor/', data),
    // save: (data, isAdd) =>
    //     isAdd ? requests.post('/monitor/', data) : ,
    loadGridData: (id, params) => requests.get(`/monitor/gridData/${id}/${convertToGetParams(params)}`),
    saveGrid: (data) => requests.post('/monitor/gridData', data),
    edit: (id, data) => requests.put(`/monitor/${id}`, data),
    getGridData: (id) => requests.get(`/monitor/getDataToUpdate/${id}`),
    getPDF: (id, params) => requests.get(`/monitor/gridDataPdf/${id}/${convertToGetParams(params)}`),
    report: (id) => requests.get(`/monitor/report/${id}`)
};

const subscriptions = {
    list: (params) => requests.get(`/subscriptions${convertToGetParams(params)}`),
    load: (id) => requests.get(`/subscriptions/${id}`),
    remove: (id) => requests.del(`/subscriptions/${id}`),
    save: (values, isAdd) =>
        isAdd ? requests.post('/subscriptions/', values, true) : requests.put(`/subscriptions/${values.id}`, values),
}

const TaskTemplates = {
    list: (params) => requests.get(`/task_templates${convertToGetParams(params)}`),
    load: (uuid) => requests.get(`/task_templates/get_details/${uuid}`),
    loadView: (uuid, params) => requests.get(`/task_templates/get_template_view/${uuid}${convertToGetParams(params)}`),
    remove: (uuid) => requests.del(`/task_templates/${uuid}`),
    save: (values) => requests.post('/task_templates/', values),
    assign: (values) => requests.post('/task_templates/assign_task_templates', values),
}

const ShiftAllowance = {
    list: (params) => requests.get(`/shift_allowance${convertToGetParams(params)}`),
    loadGroup: (params) => requests.get(`/shift_allowance/loadGroup${convertToGetParams(params)}`),
    remove: (uuid) => requests.del(`/shift_allowance/${uuid}`),
    save: (values, isAdd) => isAdd ? requests.post('/shift_allowance/', values)
        : requests.put(`/shift_allowance/${values.editId}`, values),
    removeEmergencyShift: (uuid) => requests.del(`/emergency_shifts/${uuid}`),
    getShiftAllowanceCount: (params) => requests.get(`/shift_allowance/getShiftAllowanceCount${convertToGetParams(params)}`),
    syncShiftAllowance: (uuid) => requests.put(`/shift_allowance/syncShiftAllowance/${uuid}`),
}

const ServiceRequests = {
    saveStatus: (values) => requests.put(`/serviceRequests/handleStatus/${values.id}`, values),
    saveExtendRequest: (values) => requests.put(`/serviceRequests/extendRequest/${values.id}`, values),
    remove: (id) => requests.del(`/serviceRequests/${id}`),
    assignMembers: (values) => requests.put(`/serviceRequests/assignMembers/${values.id}`, values),
    loadMemberCountForShiftAndLeaves: () => requests.get(`/serviceRequests/fetchMemberShiftsAndLeaves`),
    removeAssignedMember: (value) => requests.put(`/serviceRequests/removeAssignedMember/${value.serviceRequestId}`, value),
    load: (uuid, user_type, extendValue) => user_type ? requests.get(`/serviceRequests/${uuid}${extendValue ? `?extend=${extendValue}` : ''}`) : requests.get(`/external/serviceRequests/get/${uuid}`),
    list: (params) => params.user_type ? requests.get(`/serviceRequests${convertToGetParams(params)}`) : requests.get(`/external/serviceRequests/getList${convertToGetParams(params)}`),
    saveServiceRequest: (values, isAdd, isCustomer) => !isCustomer ? isAdd ? requests.post('/serviceRequests', values)
        : requests.put(`/serviceRequests/${values.id}`, values) : isAdd ? requests.post('/external/serviceRequests/save', values)
        : requests.put(`/external/serviceRequests/update/${values.id}`, values)
}

const External = {
    uploadFile: (params) => requests.post('/external/attachments', params),
    getAvailableClients: (email, role) => requests.get(`/external/getAvailableClients?email=${email}&role=${role}`),
    signInWithEmail: (data) => requests.post('/external/getOTP', data),
    loginWithOtp: (data) => requests.post('/external/loginWithOtp', data),
    loadCustConfig: () => requests.get('/external/loadCustomerConfig'),
}

const TimeBank = {
    loadTimeBankMember: (params) => requests.get(`/timebank/getTimeBankMembers${convertToGetParams(params)}`),
    loadTimeBankList: (params) => requests.get(`/timebank/getTimeBankList${convertToGetParams(params)}`),
    getPendingTimelogs: (params) => requests.get(`/timebank/getActiveTimelogs${convertToGetParams(params)}`),
    saveTimeBank: (values) => requests.post('/timebank/', values),
    remove: (data) => requests.del(`/timebank/${data.time_bank_id}?deleteAll=${data.deleteAll}`),
    saveHoursToCompOff: (values) => requests.post('/timebank/saveHoursToCompOff', values),
    saveToIntegration: (values) => requests.post('/timebank/saveToIntegration', values),
    desyncIntegration: (values) => requests.put(`/timebank/desyncIntegration/${values.id}`, values),
    resetCompOffToTimeBank: (values) => requests.put(`/timebank/resetCompOffToTimeBank/${values.id}`, values),
    deleteAllByDate: (data) => requests.del(`/timebank/deleteAllByDate?user_id=${data.user_id}&for_date=${data.for_date}`),
}

const OvertimeBank = {
    loadEmployees: (params) => requests.get(`/overtime_bank/getEmployees${convertToGetParams(params)}`),
    loadEmployeeOvertimeTotals: (params = {}) => requests.get(`/overtime_bank/getEmployeeOvertimeTotals${convertToGetParams(params)}`),
    loadOvertimeTransactions: (params) => requests.get(`/overtime_bank/getOvertimeTransactions${convertToGetParams(params)}`),
    loadOvertimeTransaction: (id) => requests.get(`/overtime_bank/getOvertimeTransaction/${id}`),
    loadOvertimeTransactionsForDateAndType: (params) => requests.get(`/overtime_bank/getOvertimeTransactionsForDateAndType${convertToGetParams(params)}`),
    updatePaidOvertimeBalance: (data) => requests.post('/overtime_bank/updatePaidOvertimeBalance', data),
}

const Roster = {
    createRosterTemplate: (data) => requests.post(`/roster/createRosterTemplate`, data),
    updateRosterTemplate: (id, data) => requests.put(`/roster/updateRosterTemplate/${id}`, data),
    updateRosterAndEmployeeTemplate: (id, data) => requests.put(`/roster/updateRosterAndEmployeeTemplate/${id}`, data),
    getRosterTemplates: (values) => requests.get(`/roster/getActiveRosterTemplates${convertToGetParams(values)}`),
    getPublishedRosterTemplates: (values) => requests.get(`/roster/getPublishedRosterTemplates/${convertToGetParams(values)}`),
    getRosterTemplateByUserId: (userId, values) => requests.get(`/roster/getRosterTemplateByUserId/${userId}${convertToGetParams(values)}`),
    getExpiredRosterDetailsByUserId: (userId, values) => requests.get(`/roster/getExpiredRosterDetailsByUserId/${userId}${convertToGetParams(values)}`),
    getRosterByUserIdAndDate: (userId, values) => requests.get(`/roster/getRosterByUserIdAndDate/${userId}${convertToGetParams(values)}`),
    createRosterFromExistingTemplate: (data) => requests.post(`/roster/createRosterFromExistingTemplate`, data),
    createRosterWithQuickPlanner: (data) => requests.post(`/roster/createRosterWithQuickPlanner`, data),
    isTemplateAssignedToOthers: (templateId, userId) => requests.get(`/roster/isTemplateAssignedToOthers/${templateId}/${userId}`),
    publishRoster: (data) => requests.post(`/roster/publishRoster`, data),
    sendRosterForApproval: (values) => requests.post(`/roster/sendRosterForApproval`, values),
    list: (params, isGuest) => !isGuest
        ? requests.get(`/roster${convertToGetParams(params)}`)
        : requests.get(`/external/roster/getActiveRosterShifts${convertToGetParams(params)}`),
    loadResources: (params) => requests.get(`/external/roster/resources${convertToGetParams(params)}`),
    approveOrRejectRoster: (data) => requests.post(`/roster/approveOrRejectRoster`, data),
    getRosterResources: (data) => requests.get(`/roster/rosterResources${convertToGetParams(data)}`),
    getRuleBasedDepartments: (data) => requests.get(`/roster/getRuleBasedDepartments${convertToGetParams(data)}`),
    deleteTemplate: (id) => requests.del(`/roster/${id}`),
    loadResourceList: (values) => requests.get(`/roster/resourceListForRosterTemplate${convertToGetParams(values)}`),
    downloadExcelReport: (params) => requests.get(`/roster/downloadExcelReport${convertToGetParams(params)}`),
    getActiveRosters: (params) => requests.get(`/roster/activeRosters${convertToGetParams(params)}`),
    createWorkPatternTemplate: (data) => requests.post(`/roster/createWorkPatternTemplate`, data),
    getWorkPatterns: (params) => requests.get(`/roster/getWorkPatterns${convertToGetParams(params)}`),
    getWorkPatternSelectionDetails: (params) => requests.get(`/roster/getWorkPatternSelectionDetails${convertToGetParams(params)}`),
    assignWorkPattern: (data) => requests.post(`/roster/assignWorkPattern`, data, true),
    getWorkPatternAssignments: (params) => requests.get(`/roster/getWorkPatternAssignments${convertToGetParams(params)}`),
    updateWorkPattern: (data) => requests.put(`/roster/updateWorkPattern`, data),
    generateFromPattern: (data) => requests.post(`/roster/generateFromPattern`, data),
    togglePatternAutomation: (assignmentId, data) => requests.put(`/roster/togglePatternAutomation/${assignmentId}`, data),
    updateAssignmentEndDate: (assignmentId, data) => requests.put(`/roster/updateAssignmentEndDate/${assignmentId}`, data),
    deactivateWorkPattern: (id) => requests.put(`/roster/deactivateWorkPattern/${id}`),
    updateUserAssignmentPatterns: (data) => requests.post(`/roster/updateUserAssignmentPatterns`, data),
    validateAssignmentConflicts: (data) => requests.post(`/roster/validateAssignmentConflicts`, data),
    getWorkPatternHistory: (params) => requests.get(`/roster/getWorkPatternHistory${convertToGetParams(params)}`),
    getFCodePlacements: (employeeRosterId) => requests.get(`/roster/fcodePlacements/${employeeRosterId}`),
    getClientFCodePlacements: (params) => requests.get(`/roster/fcodePlacementsForClient${convertToGetParams(params)}`),
    updateFCodePlacement: (id, data) => requests.post(`/roster/fcodePlacement/${id}`, data),
}

const UrgentCalls = {
    getWeekCounts: (params) => requests.get(`/urgent_calls${convertToGetParams(params)}`),
    getUrgentForTheDay: () => requests.get('/urgent_calls/urgentForTheDay'),
    getUrgentForTheWeek: (weekNumber, params) => requests.get(`/urgent_calls/urgentForTheWeek/${weekNumber}${convertToGetParams(params)}`),
    getUrgentCallForEmployee: (userId, weekNumber, year) => requests.get(`/urgent_calls/urgentCallForEmployee/${userId}/week/${weekNumber}?year=${year}`),
    bulkCreate: (data) => requests.post('/urgent_calls', data),
    update: (userId, data) => requests.put(`/urgent_calls/${userId}`, data),
    delete: (id) => requests.del(`/urgent_calls/${id}`),
    syncToPayroll: (data) => requests.put(`/urgent_calls/syncToPayroll/employee/${data.id}/week/${data.weekNumber}?year=${data.year}`),
    desyncToPayroll: (data) => requests.put(`/urgent_calls/desyncToPayroll/employee/${data.id}/week/${data.weekNumber}?year=${data.year}`),
    deleteWeek: (params) => requests.del(`/urgent_calls${convertToGetParams(params)}`),
    getUrgentCallForEmployeeForDate: (userId, forDate) => requests.get(`/urgent_calls/urgentCallForEmployeeForDate/${userId}/forDate/${forDate}`),
    updateCustomerCareHours: (data) => requests.put('/urgent_calls/updateCustomerCareHoursForDate', data),
    move: (data) => requests.put('/urgent_calls/move', data),
    copy: (data) => requests.put('/urgent_calls/copy', data),
}

const Skills = {
    list: (params) => requests.get(`/skills${convertToGetParams(params)}`),
    remove: (uuid) => requests.del(`/skills/${uuid}`),
    save: (values, isAdd) => isAdd ? requests.post('/skills', values) : requests.put(`/skills/${values.id}`, values),
    getSkillsDetails: (params) => requests.get(`/skills/getSkillsDetails${convertToGetParams(params)}`),
    getSkillUserDetails: (params) => requests.get(`/skills/getSkillUserDetails${convertToGetParams(params)}`),
}

const ResourcePlan = {
    save: (values) => requests.post('/resource_plans', values),
    dateWiseCount: (params) => requests.get(`/resource_plans/dateWiseCount${convertToGetParams(params)}`),
    getPlan: (params) => requests.get(`/resource_plans/${convertToGetParams(params)}`),
}

const Notifications = {
    getMasterNotifications: () => notificationRequests.get('/notifications/getMasterNotifications'),
    createMasterNotification: (data) => notificationRequests.post('/notifications/createMasterNotifications', data),
    updateMasterNotification: (id, data) => notificationRequests.put(`/notifications/updateMasterNotification/${id}`, data),
    updateMasterMessage: (id, data) => notificationRequests.put(`/notifications/updateMasterMessage/${id}`, data),
    createMasterMessage: (data) => notificationRequests.post('/notifications/createMasterMessage', data),
    getTemplates: (params) => notificationRequests.get(`/notifications/templates${convertToGetParams(params)}`),
    createTemplate: (data) => notificationRequests.post('/notifications/templates', data),
    updateTemplate: (id, data) => notificationRequests.put(`/notifications/templates/${id}`, data),
    deleteTemplate: (id) => notificationRequests.del(`/notifications/templates/${id}`),
    getClientMessages: () => notificationRequests.get('/notifications/clientMessages'),
    upsertClientMessage: (masterId, data) => notificationRequests.put(`/notifications/clientMessages/${masterId}`, data),
    deleteClientMessage: (masterId) => notificationRequests.del(`/notifications/clientMessages/${masterId}`),
    bulkAssignNotificationTemplate: (data) => notificationRequests.post('/notifications/bulk-assign-template', data),
    getBulkAssignUsers: (params) => notificationRequests.get(`/notifications/users${convertToGetParams(params)}`),
    sendImmediateNotificationToUser: (data) => notificationRequests.post('/notifications/send-immediate', data),
    getUserNotificationSettings: (userId) => notificationRequests.get(`/notifications/user-settings/${userId}`),
    saveUserNotificationSettings: (userId, settings) => notificationRequests.put(`/notifications/user-settings/${userId}`, { settings }),
    getUserChannelPreferences: () => notificationRequests.get('/notifications/user-channel-preferences'),
    saveUserChannelPreferences: (preferences) => notificationRequests.put('/notifications/user-channel-preferences', { preferences }),
}

const agent = {
    config: appConfigs,
    Auth,
    Clients,
    Users,
    BizTypes,
    Dashboard,
    Projects,
    Chat,
    Tasks,
    Timelogs,
    Vacations,
    Absences,
    Locked,
    Schedule,
    Deviation,
    ExtraDoc,
    checklist,
    convertToGetParams,
    documents,
    visitors,
    Recipients,
    Signature,
    contracts,
    contractslist,
    Monitor,
    subscriptions,
    TaskTemplates,
    UserGroups,
    PermissionGroups,
    ShiftAllowance,
    ServiceRequests,
    External,
    TimeBank,
    OvertimeBank,
    Roster,
    UrgentCalls,
    Skills,
    ResourcePlan,
    Notifications,
};

export default agent;